import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref } from "vue"

const _hoisted_1 = { class: "ws_pb10" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, nextTick, computed } from 'vue'
import { PAGE_SIZES, DEVICE_STATUS_ENUM, CODE_ENUM } from '@/common'
import { queryDeviceInstructPage } from '@/api'
import moment from 'moment'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'sub-device-command-record-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'on-change'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

watch(
  () => props.visible,
  () => {
    props.visible && fetchList()
  }
)

const handleClose = () => {
  $emit('update:visible', false)
  dateRange.value = ''
  pageParams.value.curPage = 1
  total.value = 0
}

const dateRange = ref('')

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const tableData = ref([])
const tableLoading = ref(false)

const fetchList = async () => {
  const { deviceId } = props.data

  let params = {}
  if (!isEmpty(dateRange.value)) {
    const [start, end] = dateRange.value
    params = {
      startTime: moment(start).valueOf(),
      endTime: moment(end).valueOf(),
    }
  }
  const res: any = await queryDeviceInstructPage({
    deviceId,
    ...pageParams.value,
    ...params,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const col: any = [
  {
    prop: 'createDate',
    label: '下发时间',
    formatter: ({ createDate }: any) => {
      return moment(createDate).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  {
    prop: 'instructName',
    label: '指令内容',
  },
  {
    prop: 'repStatus',
    label: '响应状态',
  },
  {
    prop: 'instructOutput',
    label: '响应内容',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: "下发记录",
    size: "882px",
    "before-close": handleClose,
    "label-position": "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: handleClose,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_date_picker, {
          modelValue: dateRange.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
          type: "daterange",
          "range-separator": "-",
          "start-placeholder": "开始时间",
          "end-placeholder": "结束时间"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          onClick: fetchList,
          type: "primary",
          class: "ws_ml20"
        }, {
          default: _withCtx(() => [
            _createTextVNode("查询")
          ]),
          _: 1
        })
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table ws_mt24"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, { ...item }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64))
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})